module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/filled-colored-buttons/filled-colored-buttons.component.scss
// module id = ./src/app/features/buttons/filled-colored-buttons/filled-colored-buttons.component.scss
// module chunks = main